import { Dialog, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import FailedImageDetails from './FailedImageDetails';
import { useAppSelector } from '../../../app/hooks';
import { selectFailedCameraUploads } from '../../../app/slices/eventsSlice';

interface IProps {
  cameraId?: string;
  failedCount?: string;
  date?: string;
}

function FailedImage({ cameraId, failedCount, date }: IProps) {
  const failedCamera = useAppSelector(selectFailedCameraUploads);

  const [openDialog, setOpenDialog] = useState(false);

  const handleInformationClick = () => {
    setOpenDialog(true);
  };

  const handleInformationClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <div>
        <Typography
          variant='h4'
          sx={{ display: 'inline-block', fontWeight: 'normal', mr: 1, mb: 1 }}
          color='text.secondary'
        >
          {'IMAGES FAILED:'}
        </Typography>
        <Typography
          variant='h4'
          sx={{ display: 'inline-block', fontWeight: 'bold' }}
        >
          {failedCount}
        </Typography>
        <IconButton
          data-testid='error-button'
          sx={{ py: 0 }}
          onClick={handleInformationClick}
        >
          <InfoIcon fontSize='small' color='error' />
        </IconButton>
      </div>
      {!!failedCamera && (
        <Dialog
          open={openDialog}
          fullWidth={true}
          maxWidth='sm'
          onClose={handleInformationClose}
        >
          <FailedImageDetails
            onClose={handleInformationClose}
            cameraId={cameraId}
            date={date}
            failedCamera={failedCamera}
          />
        </Dialog>
      )}
    </>
  );
}

export default FailedImage;
